import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConnectionService } from '../../services/connection.service';
import { MediaService } from '../../services/media.service';
import { createDefaultImageReader, createDefaultImageWriter, getEditorDefaults, processImage } from '@pqina/pintura';
import { DomSanitizer } from '@angular/platform-browser';
import { Media } from '@contracts/interfaces/media.interfaces';

export interface DialogData {
    media: Media;
    saveAsFileName: string;
    direct: boolean;
}

@Component({
  selector: 'app-image-download-dialog',
  templateUrl: './image-download-dialog.component.html',
  styleUrls: ['./image-download-dialog.component.scss']
})
export class ImageDownloadDialogComponent {

  image: string;
  saveAsFileName: string;

  width: number = 0;
  height: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ImageDownloadDialogComponent>,
    public connectionService: ConnectionService,
    public mediaService: MediaService,
    private domSanitizer: DomSanitizer
    ) { }

  ngOnInit() {
    console.log(this.data)

    this.mediaService.check(this.data.media).subscribe((r: any) => {
      let media = this.connectionService.address + this.data.media.path + this.data.media.filename;
      console.log(media)
      if  (this.data.direct) {
        processImage(media, {
          imageReader: createDefaultImageReader(),
          imageWriter: createDefaultImageWriter(),
        }).then((imageState) => {
          downloadFile(imageState.dest);
          this.dialogRef.close()
        })
      }


      // processImage(this.image, {
      //   imageReader: createDefaultImageReader(),
      //   imageWriter: createDefaultImageWriter(),
      //   imageCropAspectRatio: 1,
      // }).then((imageState) => {
      //   downloadFile(imageState.dest);
      //   this.dialogRef.close()
      // })

    });
  }

  download() {
    let targetSize = null;
    if (this.width != 0 || this.height != 0) {
      targetSize = {
        width: this.width,
        height: this.height      
      }
    }


    processImage(this.image, {
      imageReader: createDefaultImageReader(),
      imageWriter: createDefaultImageWriter(),
      //imageCropAspectRatio: 1,
    }).then((imageState) => {
      downloadFile(imageState.dest);
      this.dialogRef.close()
    })
  }

  
  @ViewChild('editor') editor?: any;

  editorDefaults: any = getEditorDefaults();

  handleEditorProcess(imageState: any): void {
      downloadFile(imageState.dest);
  }


}

const downloadFile = (file: File): void => {
  // Create a hidden link and set the URL using createObjectURL
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = URL.createObjectURL(file);
  link.download = file.name;

  // We need to add the link to the DOM for "click()" to work
  document.body.appendChild(link);
  link.click();

  // To make this work on Firefox we need to wait a short moment before clean up
  setTimeout(() => {
      URL.revokeObjectURL(link.href);
      link.parentNode.removeChild(link);
  }, 0);
};